import { CreateProvisionWasm } from "@pdfking/library-core"

import { CreateFunctions } from "#bindings"

import wasm32 from "../public/libs/binary32.wasm"
import wasm64 from "../public/libs/binary64.wasm"

export const Provision = CreateProvisionWasm({ wasm32, wasm64 }, i => {
  const fns = CreateFunctions(i)
  fns.init()
  return fns
})
